/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Managelpspecificndas_Nolps_Title5Inputs */

const en_coinvestments_managelpspecificndas_nolps_title5 = /** @type {(inputs: Coinvestments_Managelpspecificndas_Nolps_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organisations`)
};

/**
* | output |
* | --- |
* | "No organisations" |
*
* @param {Coinvestments_Managelpspecificndas_Nolps_Title5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_managelpspecificndas_nolps_title5 = /** @type {((inputs?: Coinvestments_Managelpspecificndas_Nolps_Title5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Managelpspecificndas_Nolps_Title5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_managelpspecificndas_nolps_title5(inputs)
});
export { coinvestments_managelpspecificndas_nolps_title5 as "coInvestments_manageLpSpecificNdas_noLps_title" }